import React, { useEffect, useMemo, useState } from 'react';

import { PageHeader } from '../../shared/ui';
import ModalConfirm from '../../shared/ui/modal-confirm/ui/ModalConfirm';
import Filter from '../../shared/ui/filter/Filter';
import { getAdminPrograms } from '../../shared/api/programs.services';
import { matchesActiveStatus, matchesSearch, useListFilters } from '../../shared/lib/useListFilters';
import ProgramsList from '../../widgets/programs-list/ui/ProgramsList';
import { useProgramsFilters } from '../../widgets/programs-list/config/filter';

const SEARCH_FIELDS = ['title', 'ageLabel', 'summary', 'slug'];

export default function ProgramsPage() {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const programsFilters = useProgramsFilters();
  const { query, get } = useListFilters();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const result = await getAdminPrograms();
        setPrograms(result?.items || []);
      } catch (error) {
        console.error('Помилка при завантаженні даних:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Програм небагато — фільтруємо на місці, без зайвих запитів на сервер.
  const status = get('status');
  const visiblePrograms = useMemo(
    () =>
      programs.filter(
        (program) =>
          matchesSearch(program, query, SEARCH_FIELDS) && matchesActiveStatus(program, status)
      ),
    [programs, query, status]
  );

  return (
    <>
      <ModalConfirm title="Ви впевнені, що хочете видалити цю програму?" />

      <PageHeader
        placeholder={'Пошук за назвою або віком'}
        createLink={'/programs-rewrite/create'}
        filters={programsFilters}
      />
      <Filter fields={programsFilters} />

      <section className="section-admin">
        {loading ? (
          <p>Завантаження...</p>
        ) : (
          <ProgramsList
            data={{ items: visiblePrograms, total: visiblePrograms.length }}
            totalCount={programs.length}
          />
        )}
      </section>
    </>
  );
}
